const ITEMS = [
  "Reparación de guardas",
  "Reconstrucción CNC",
  "Wipers y rascadores",
  "Lamelas de acero",
  "Guías Nylamid",
  "Diagnóstico el mismo día",
];

export default function RepairMarquee({ items = ITEMS }) {
  const track = [...items, ...items];
  return (
    <div
      data-testid="repair-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-[#0A1B35] py-6"
      aria-hidden="true"
    >
      <div className="gf-marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {track.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span
                  className={`font-display font-black uppercase tracking-tight text-2xl lg:text-4xl px-8 ${
                    i % 2 === 0 ? "text-white/90" : "gf-text-outline"
                  }`}
                >
                  {item}
                </span>
                <span className="w-2.5 h-2.5 bg-[#00B4D8] rotate-45 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
